import { render } from "./bPanel.vue?vue&type=template&id=31946672&scoped=true"
import script from "./bPanel.vue?vue&type=script&lang=js"
export * from "./bPanel.vue?vue&type=script&lang=js"

import "./bPanel.vue?vue&type=style&index=0&id=31946672&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31946672"]])

export default __exports__